/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get, warp-drive/no-legacy-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
// External Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import MediaTypes from '@linc-technologies/linced-common/enums/media-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import SharingLevel from '@linc-technologies/linced-common/enums/media-sharing-level';
import moment from 'moment';
// Internal Imports
import LearnerFlag from 'linced-app/enums/learner-flag';
import { getKeyAndSourceFromUpload } from '@linc-technologies/linced-common/utils/uppy';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class UserBadgeCard extends Component {
  @tracked
  navCardOpen;

  @action
  setNavCardOpen(value) {
    this.navCardOpen = value;
  }

  // Services
  @service
  features;

  @service
  options;

  @service
  roles;

  @service
  session;

  @service
  store;

  @service
  strings;

  @service
  toaster;

  @alias('session.school.jurisdiction')
  jurisdiction;

  LearnerFlag = LearnerFlag;

  PersonType = PersonType;

  Jurisdiction = Jurisdiction;

  Scopes = Scopes;

  linkImage = true;

  imageLinkRoute = 'people.person';

  minimal = false;

  @alias('session.school.heroSuiteEnabled')
  heroSuiteEnabled;

  @computed('user.type')
  get isCaregiver() {
    return this.get('user.type') === PersonType.CAREGIVER;
  }

  // NSW learner cards show extra detail lines (DoB and jurisdictional ID) under the name.
  @computed('jurisdiction', 'user.type')
  get showLearnerDetails() {
    return (
      this.jurisdiction === Jurisdiction.AU_NSW &&
      this.get('user.type') === PersonType.LEARNER
    );
  }

  @computed('user.dob')
  get formattedDOB() {
    return moment(this.get('user.dob')).format('DD/MM/YYYY');
  }

  @computed(
    'user.{id,type}',
    'roles.currentUserIsRestricted',
    'session.person.id',
  )
  get hasAccess() {
    if (this.get('session.person.id') === this.get('user.id')) {
      return true;
    }
    return !this.roles.currentUserIsRestricted;
  }

  allowProfileUploads = false;

  @tracked
  uploading;

  @action
  startUpload() {
    if (!this.allowProfileUploads) {
      return;
    }
    this.uploading = true;
  }

  @action
  handleUpload(file, upload) {
    if (!this.allowProfileUploads) {
      return;
    }
    let { key, mediaSource } = getKeyAndSourceFromUpload(upload);
    let person = this.user;

    let sharedWith = SharingLevel.SCHOOL;

    if (!isEmpty(person.get('caregiver'))) {
      sharedWith = SharingLevel.PUBLIC;
    }

    this.store
      .createRecord('media', {
        schoolId: this.get('session.school'),
        personId: this.get('session.person'),
        sharedWith,
        mediaType: MediaTypes.IMAGE,
        mediaSource: mediaSource,
        mimeType: file.type,
        fileName: file.name,
        storageKey: key,
        fileSize: file.size,
      })
      .save()
      .then((media) => {
        person.set('profileMedia', media.id);
        return person.save();
      })
      .catch(() => {
        person.rollbackAttributes(); // Revert unsaved changes, i.e. the profileMediaId
        this.toaster.error('Error saving profile image!');
      })
      .finally(() => {
        this.uploading = false;
      });
  }

  @action
  handleUploadError() {
    this.toaster.error('Error saving profile image!');
  }
}
